import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { lifestyleApi } from "../apiService/api";
import { getUrlParams } from "../apiService/timespam";
import "./MyCareTeam.css";

export default function MyCareTeam() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    const { encryptedId } = getUrlParams();
    if (!encryptedId) return;

    lifestyleApi
      .goqiiData(encryptedId)
      .then((res) => {
        if (res?.data?.code === 200) setData(res.data.data);
      })
      .catch(console.error);
  }, []);

  if (!data) return null;

  const members = [
    data.expertName && {
      label: t("mct.expert"),
      name: data.expertName,
      img: data.expertImage,
      link: data.expertLink,
    },
    data.coachName && {
      label: t("mct.coach"),
      name: data.coachName,
      img: data.coachImage,
      link: data.coachLink,
    },
  ].filter(Boolean);

  if (!members.length) return null;

  return (
    <div className="mct-container">
      <div className="mct-inner">
        <h1 className="mct-title">{t("mct.title")}</h1>
        <div className="mct-row">
          {members.map((m, i) => (
            <div key={i} className="mct-member">
              <div
                className="mct-circle"
                onClick={() => m.link && (window.location.href = m.link)}
              >
                <img src={m.img} alt={m.name} />
              </div>
              <h2 className="mct-role">{m.label}</h2>
              <h3 className="mct-name">{m.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
